var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',{attrs:{"page":'auth'}},[_c('template',{slot:"title"},[_c('title-component',{attrs:{"title":_vm.$t('auth.login.title'),"type":"h1"}}),_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('auth.login.message'))}})],1),_c('login-form')],2)}
var staticRenderFns = []

export { render, staticRenderFns }